import React, { Fragment } from "react";
import { Link } from 'react-router-dom';

import "./AttributeColor.css";

class AttributeColor extends React.Component {
  constructor(props) {
    super(props);
    //this.toggleClass = this.toggleClass.bind(this);
    this.state = { imageActive: false };
  }

  render() {
    return (
      <Fragment>
        <div className="mn-grid__row mn-grid__row--gap-lg">
            <div className="mn-grid__col mn-grid__col--gap-lg mn-grid__col--flex-initial">
                <label for="" className="uk-form-label uk-flex uk-flex-between">انتخاب رنگ کالا: <span className="uk-form-label__required"></span>
                   {/* <Link className="search-link" id="newColorRequestModalBtn">درخواست رنگ جدید</Link> */}
                </label>
                <div className="field-wrapper" id="attributesContainer">
                    <div className="mn-variant__attributes-container">
                    {this.props.colorsData.map((color, index) => (    
                        <button type="button"
                        className="mn-variant-btn js-add-variant"
                        data-attribute-value={color.title} 
                        data-attribute-id={color.id} 
                        data-hex={"#"+color.hexCode }
                        data-title={color.title}
                        onClick={this.props.onAddVariantColorHandler.bind(this, {
                          id: color.id,
                          title: color.title,
                          hexCode: color.hexCode,
                          index: index,
                        })}>
                            <span className="mn-variant-btn__label">
                                <span className="mn-variant-btn__color" style={{backgroundColor: "#"+color.hexCode }}></span>
                                <span className="mn-variant-btn__text">{color.title}</span>
                                <span className={[ "mn-variant-btn__counter", `${color.count==0 && "hidden"}`, ].join(" ")}>
                                    (<span className="js-variant-count">{color.count}</span>)
                                </span>
                            </span>
                        </button>
                    ))}
                    </div>
                </div>
            </div>
        </div>  
      </Fragment>
    );
  }
}

export default AttributeColor;

  